export function chatRequiresUpgrade(item) {
	const isFreeJob = this.freeJob && this.freeJob.id == item.job.id;

	// No upgrade if I created it
	if (item.job.creatorId == this.$activeUser.id) {
		return false;
	}
	
	// If I'm a trial account
	if (this.isTrialing && !isFreeJob && !item.isJobBooked) {
		return true;
	}

	return false;
}